import Loading from '@/packages/loadingBox/src/Loading'
import './src/directive'

let instance,
  refs = 0,
  hasInit = false,
  timer = null

Loading.install = function(Vue) {
  Vue.component(Loading.name, Loading)

  Vue.prototype.$loadBoxing = () => {
    if (!instance) {
      const component = Vue.extend(this)
      instance = new component()
    }

    instance.start = start

    instance.stop = stop

    return instance
  }
}

function start() {
  ++refs
  const element = this.$mount().$el

  if (hasInit) return (element.style.display = 'flex')

  document.body.appendChild(element)
  hasInit = true
}

function stop() {
  --refs
  clearTimeout(timer)

  timer = setTimeout(() => {
    if (refs <= 0) {
      const element = this.$mount().$el
      element.style.display = 'none'
    }
  }, 300)
}

export default Loading
